import { LimitState } from 'capacity/types'

export const LIMIT_MAX = 100000

export const toLimitState = (value: number | null | undefined): LimitState => {
    if (value === null || value === undefined) {
        return { kind: 'noLimit' }
    }
    if (value === 0) {
        return { kind: 'closed' }
    }
    return { kind: 'number', value }
}

export const fromLimitState = (state: LimitState): number | null => {
    switch (state.kind) {
        case 'noLimit':
            return null
        case 'closed':
            return 0
        default:
            return state.value
    }
}

export const parseLimitInput = (text: string): LimitState | 'invalid' => {
    const trimmed = text.trim()
    if (trimmed === '') {
        return { kind: 'noLimit' }
    }
    if (!/^\d+$/.test(trimmed)) {
        return 'invalid'
    }
    const value = Number(trimmed)
    if (value > LIMIT_MAX) {
        return 'invalid'
    }
    return toLimitState(value)
}

export const limitStatesEqual = (a: LimitState, b: LimitState): boolean =>
    a.kind === b.kind && (a.kind !== 'number' || b.kind !== 'number' || a.value === b.value)
